import React from 'react';
import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck,FiArrowRight,FiZap,FiShield,FiSmartphone,FiTrendingUp,FiSettings,FiUsers,FiCalendar}=FiIcons;

const SitiWeb=()=> {
  const packages=[
    {
      name: "Sito Vetrina",
      price: "a partire da €890",
      description: "Perfetto per professionisti e piccole attività",
      features: [
        "Design responsive mobile-first",
        "Fino a 3 pagine ottimizzate",
        "Ottimizzazione SEO base",
        "Certificato SSL incluso",
        "Hosting per 1 anno",
        "Assistenza 3 mesi"
      ],
      popular: false
    },
    {
      name: "Sito Business",
      price: "a partire da €1.490",
      description: "Ideale per PMI che vogliono crescere online",
      features: [
        "Tutto del pacchetto Vetrina",
        "Fino a 5 pagine",
        "Google Analytics e Search Console",
        "Moduli di contatto avanzati",
        "Ottimizzazione velocità avanzata",
        "Assistenza 6 mesi"
      ],
      popular: true
    },
    {
      name: "Sito Enterprise",
      price: "a partire da €2.490",
      description: "Per aziende che puntano all'eccellenza",
      features: [
        "Tutto del pacchetto Business",
        "Fino a 10 pagine",
        "Blog integrato",
        "Area riservata clienti",
        "Integrazioni CRM",
        "Multilingua",
        "Backup giornalieri",
        "Assistenza 12 mesi"
      ],
      popular: false
    }
  ];

  const technologies=[
    {
      name: "WordPress",
      description: "CMS più utilizzato al mondo"
    },
    {
      name: "Next.js",
      description: "Framework React per performance"
    },
    {
      name: "Elementor Pro",
      description: "Page builder professionale"
    },
    {
      name: "Bricks Builder",
      description: "Builder leggero e veloce"
    }
  ];

  const caseStudy={
    client: "Ristorante Napoli Centro",
    results: [
      {
        metric: "+120%",
        description: "Prenotazioni online"
      },
      {
        metric: "+85%",
        description: "Traffico organico"
      },
      {
        metric: "0.4s",
        description: "Tempo di caricamento"
      },
      {
        metric: "95/100",
        description: "PageSpeed Score"
      }
    ]
  };

  const faq=[
    {
      question: "Quanto tempo serve per realizzare un sito web?",
      answer: "I tempi dipendono dalla complessità: 7-14 giorni per un sito vetrina,15-30 giorni per siti business più articolati. Ti forniamo sempre una timeline precisa dopo l'analisi del progetto."
    },
    {
      question: "Il sito sarà ottimizzato per i dispositivi mobili?",
      answer: "Assolutamente sì. Tutti i nostri siti sono sviluppati con approccio mobile-first,garantendo un'esperienza perfetta su smartphone,tablet e desktop."
    },
    {
      question: "Cosa include l'ottimizzazione SEO?",
      answer: "Ottimizzazione dei contenuti,meta tag,struttura URL,velocità di caricamento,schema markup e configurazione di Google Analytics e Search Console."
    },
    {
      question: "Posso gestire i contenuti autonomamente?",
      answer: "Sì,utilizziamo WordPress che ti permette di aggiornare testi,immagini e pagine facilmente. Ti formiamo gratuitamente sull'utilizzo."
    },
    {
      question: "Cosa succede dopo la realizzazione?",
      answer: "Offriamo assistenza tecnica,aggiornamenti di sicurezza e supporto per modifiche. Puoi scegliere il piano di manutenzione più adatto alle tue esigenze."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Realizzazione Siti Web Napoli – Siti Professionali Veloci e SEO</title>
        <meta name="description" content="Siti web su misura a Napoli. Veloci,responsive e ottimizzati SEO. WordPress,Next.js,design mobile-first. Richiedi un preventivo gratis." />
        <meta name="keywords" content="realizzazione siti web napoli,sviluppo siti vetrina napoli,siti wordpress napoli,siti professionali napoli,web design napoli" />
        <link rel="canonical" href="https://realizzazionesitiweb-napoli.it/servizi/realizzazione-siti-web-napoli" />
      </Helmet>

      {/* Hero Section - Velo scuro al 40% */}
      <section className="relative min-h-screen bg-napoli-gradient text-white overflow-hidden flex items-center">
        <div className="absolute inset-0"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?q=80&w=1920&auto=format&fit=crop')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-40"></div>
        
        <div className="relative container mx-auto px-4 py-20">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h1 style={{
      paddingTop: '50px',
      paddingBottom: '50px'
    }}
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              className="text-4xl lg:text-5xl font-poppins font-bold mb-6 text-contrast-white"
            >Realizzazione Siti Web a Napoli che Convertono</motion.h1>
            
            <motion.p
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.2}}
              className="text-xl mb-8 text-contrast-white leading-relaxed"
            >
              Siti web professionali,veloci e ottimizzati SEO per PMI,professionisti e startup di Napoli. Design responsive,tecnologie moderne e assistenza continua.
            </motion.p>
            
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: 0.4}}
              className="flex flex-col sm:flex-row gap-4 justify-center"
            >
              <Link
                to="/contatti"
                className="bg-napoli-accent hover:bg-yellow-400 text-napoli-blu font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-accent focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
              >
                Preventivo gratuito in 24h
              </Link>
              <a
                href="https://tidycal.com/sitiwebstudio/consulenza-siti-web-napoli"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-napoli-azzurro hover:bg-blue-500 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-azzurro focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
              >
                <SafeIcon icon={FiCalendar} className="w-5 h-5 mr-2 inline" />
                Prenota una consulenza
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-16 bg-napoli-light">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-poppins font-bold text-napoli-blu mb-6">
              Il tuo sito web attuale non porta clienti?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl mb-4">😔</div>
                <h3 className="font-semibold text-napoli-blu mb-2">Lento e non responsive</h3>
                <p className="text-napoli-blu font-medium">I visitatori abbandonano prima ancora di vedere i tuoi servizi</p>
              </div>
              <div className="text-center">
                <div className="text-4xl mb-4">📱</div>
                <h3 className="font-semibold text-napoli-blu mb-2">Non visibile su Google</h3>
                <p className="text-napoli-blu font-medium">Nessuno trova la tua attività quando cerca online</p>
              </div>
              <div className="text-center">
                <div className="text-4xl mb-4">💸</div>
                <h3 className="font-semibold text-napoli-blu mb-2">Design datato</h3>
                <p className="text-napoli-blu font-medium">Trasmette poca professionalità e fiducia ai potenziali clienti</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
              La nostra soluzione in 4 passi
            </h2>
            <p className="text-xl text-napoli-blu max-w-3xl mx-auto font-medium">
              Un metodo collaudato per creare siti web che generano risultati concreti
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                step: "01",
                title: "Analisi e Strategia",
                description: "Analizziamo il tuo business,i competitor e definiamo obiettivi chiari e misurabili"
              },
              {
                step: "02",
                title: "Design UX/UI",
                description: "Creiamo wireframe e design ottimizzati per la conversione e l'esperienza utente"
              },
              {
                step: "03",
                title: "Sviluppo e SEO",
                description: "Sviluppiamo con tecnologie moderne e ottimizziamo per velocità e motori di ricerca"
              },
              {
                step: "04",
                title: "Test e Lancio",
                description: "Testiamo tutto nei dettagli,formiamo il team e lanciamo con monitoraggio attivo"
              }
            ].map((step,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className="text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-napoli-azzurro to-napoli-accent rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-napoli-blu font-bold text-lg">{step.step}</span>
                </div>
                <h3 className="text-xl font-poppins font-semibold text-napoli-blu mb-3">{step.title}</h3>
                <p className="text-napoli-blu leading-relaxed font-medium">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section className="py-20 bg-napoli-light">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
              Pacchetti siti web per ogni esigenza
            </h2>
            <p className="text-xl text-napoli-blu font-medium">
              Soluzioni su misura per professionisti,PMI e aziende di Napoli
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {packages.map((pkg,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.1}}
                viewport={{once: true}}
                className={`bg-white rounded-xl p-8 shadow-lg relative ${pkg.popular ? 'border-2 border-napoli-accent' : ''}`}
              >
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-napoli-accent text-napoli-blu px-4 py-2 rounded-full text-sm font-semibold">
                      Più richiesto
                    </span>
                  </div>
                )}
                
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-poppins font-bold text-napoli-blu mb-2">{pkg.name}</h3>
                  <div className="text-3xl font-bold text-napoli-azzurro mb-2">{pkg.price}</div>
                  <p className="text-napoli-blu font-medium">{pkg.description}</p>
                </div>
                
                <ul className="space-y-3 mb-8">
                  {pkg.features.map((feature,idx)=> (
                    <li key={idx} className="flex items-center">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-napoli-accent mr-3 flex-shrink-0" />
                      <span className="text-napoli-blu font-medium">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Link
                  to="/contatti"
                  className={`block w-full text-center py-3 px-6 rounded-lg font-semibold transition-all ${
                    pkg.popular ? 'bg-napoli-accent text-napoli-blu hover:bg-yellow-400' : 'bg-napoli-azzurro text-white hover:bg-napoli-blu'
                  }`}
                >
                  Richiedi preventivo
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
              Tecnologie e strumenti che utilizziamo
            </h2>
            <p className="text-xl text-napoli-blu font-medium">
              Stack tecnologico moderno per performance e sicurezza
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {technologies.map((tech,index)=> (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-napoli-light rounded-lg flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={FiSettings} className="w-8 h-8 text-napoli-azzurro" />
                </div>
                <h3 className="font-semibold text-napoli-blu mb-2">{tech.name}</h3>
                <p className="text-napoli-blu text-sm font-medium">{tech.description}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="text-center">
              <SafeIcon icon={FiZap} className="w-12 h-12 text-napoli-accent mx-auto mb-4" />
              <h3 className="font-semibold text-napoli-blu mb-2">Performance Elevate</h3>
              <p className="text-napoli-blu font-medium">LCP medio 1.6 secondi,ottimizzazione immagini e lazy loading</p>
            </div>
            <div className="text-center">
              <SafeIcon icon={FiShield} className="w-12 h-12 text-napoli-accent mx-auto mb-4" />
              <h3 className="font-semibold text-napoli-blu mb-2">Sicurezza Totale</h3>
              <p className="text-napoli-blu font-medium">SSL,firewall,backup giornalieri e conformità GDPR</p>
            </div>
            <div className="text-center">
              <SafeIcon icon={FiSmartphone} className="w-12 h-12 text-napoli-accent mx-auto mb-4" />
              <h3 className="font-semibold text-napoli-blu mb-2">Mobile First</h3>
              <p className="text-napoli-blu font-medium">Design responsive perfetto su tutti i dispositivi</p>
            </div>
          </div>
        </div>
      </section>

      {/* Case Study Section */}
      <section className="py-20 bg-napoli-light">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
                Caso di successo: {caseStudy.client}
              </h2>
              <p className="text-xl text-napoli-blu font-medium">
                Come abbiamo trasformato la presenza online di un ristorante nel centro di Napoli
              </p>
            </div>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
              {caseStudy.results.map((result,index)=> (
                <div key={index} className="text-center">
                  <div className="text-3xl lg:text-4xl font-bold text-napoli-azzurro mb-2">{result.metric}</div>
                  <div className="text-napoli-blu font-medium">{result.description}</div>
                </div>
              ))}
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <h3 className="text-xl font-semibold text-napoli-blu mb-4">La sfida</h3>
              <p className="text-napoli-blu mb-6 font-medium">
                Il ristorante aveva un sito web datato,lento e non ottimizzato per mobile. Le prenotazioni online erano quasi inesistenti e la visibilità su Google molto bassa.
              </p>
              
              <h3 className="text-xl font-semibold text-napoli-blu mb-4">La soluzione</h3>
              <p className="text-napoli-blu mb-6 font-medium">
                Abbiamo creato un nuovo sito WordPress con design moderno,sistema di prenotazioni integrato,ottimizzazione SEO locale e galleria fotografica dei piatti.
              </p>
              
              <div className="text-center">
                <Link
                  to="/contatti"
                  className="btn-primary"
                >
                  Richiedi il tuo preventivo
                  <SafeIcon icon={FiArrowRight} className="w-4 h-4 ml-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-6">
                Domande frequenti
              </h2>
              <p className="text-xl text-napoli-blu font-medium">
                Risposte alle domande più comuni sulla realizzazione di siti web
              </p>
            </div>
            
            <div className="space-y-6">
              {faq.map((item,index)=> (
                <motion.div
                  key={index}
                  initial={{opacity: 0,y: 20}}
                  whileInView={{opacity: 1,y: 0}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  viewport={{once: true}}
                  className="bg-napoli-light rounded-lg p-6"
                >
                  <h3 className="text-lg font-semibold text-napoli-blu mb-3">{item.question}</h3>
                  <p className="text-napoli-blu leading-relaxed font-medium">{item.answer}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section - Velo scuro al 40% */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?q=80&w=1920&auto=format&fit=crop')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div className="absolute inset-0 bg-black opacity-40"></div>
        
        <div className="relative container mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-4xl font-poppins font-bold mb-6 text-white drop-shadow-lg">
            Pronto per il tuo nuovo sito web?
          </h2>
          <p className="text-xl mb-8 text-white max-w-2xl mx-auto font-medium drop-shadow-md">
            Iniziamo subito con un'analisi gratuita del tuo progetto. Ti risponderemo entro 24 ore con un preventivo dettagliato.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contatti"
              className="bg-napoli-accent hover:bg-yellow-400 text-napoli-blu font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-accent focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
            >
              Preventivo gratuito in 24h
            </Link>
            <a
              href="https://tidycal.com/sitiwebstudio/consulenza-siti-web-napoli"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-napoli-azzurro hover:bg-blue-500 text-white font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-napoli-azzurro focus:ring-opacity-50 shadow-lg hover:shadow-xl text-lg"
            >
              <SafeIcon icon={FiCalendar} className="w-5 h-5 mr-2 inline" />
              Prenota una consulenza
            </a>
          </div>
          
          <div className="mt-8 text-white font-medium drop-shadow-md">
            <p>✓ Preventivo in 24h • ✓ Nessun vincolo • ✓ Consulenza gratuita</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default SitiWeb;